import { get } from 'lodash';
import psHttp from '@patsnap/common-ps-http';
import { accountServiceApiUrlPrefix } from '../../config/constants';

export function getSuccessPageApi(lastPage) {
    return psHttp({
        url: `${accountServiceApiUrlPrefix}/account-login/success-page`,
        method: 'POST',
        data: lastPage,
    }).then(res => {
        return get(res, 'data.data');
    });
}

export function getLoginPageApi() {
    return psHttp({
        url: `${accountServiceApiUrlPrefix}/account-settings/setting/login-page`,
        method: 'GET',
    }).then(res => {
        return get(res, 'data.home_page');
    });
}

export function getPackageDataApi() {
    return psHttp({
        url: `${accountServiceApiUrlPrefix}/account-info/package-data`,
        method: 'GET',
    }).then(res => {
        return get(res, 'data.data');
    });
}
